import type { ReactNode } from 'react';
import React from 'react';
import { CanvasProvider } from '../../../providers/canvas-provider';
type PropsT = {
  children: ReactNode;
};
const Canvas = ({
  children
}: PropsT) => {
  return <CanvasProvider>{children}</CanvasProvider>;
};
export default Canvas;